import apiClient from './apiClient';

export default {
  uploadFile: ({ formData, params, bucket }) => apiClient.post(`/v1/media/upload/${bucket}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    params,
  }),
};
